import React, { useEffect, useState } from 'react'
import { useMantineColorScheme, Image, Button } from '@mantine/core';
import NotificationsDropdown from '../file-explorer/dropdowns/NotificationsDropdown';
import { useGlobalContext } from '@/context/global-context';
import { usePathname } from 'next/navigation';
import { Tooltip, Notification } from '@mantine/core';
import { AnimatePresence, motion } from 'framer-motion';
import { notificationVariants } from '@/utils/general';
import DocumentPreviewModal2 from '../document-previewer/DocumentPreviewModal2';

function ColorSchemeToggle({ policyPage = false }) {
    const { setColorScheme } = useMantineColorScheme();
    const pathname = usePathname();
    // const colorScheme = useComputedColorScheme(); //SSR incompatible
    const { previewItem, previewOpen, setPreviewOpen, DSPolling, loader } = useGlobalContext();
    const [colorScheme, setClientColorScheme] = useState<"light" | "dark">("light");

    useEffect(() => {
        const theme = localStorage.getItem('mantine-color-scheme') || "light";
        setClientColorScheme(theme as "light" | "dark");

        if (typeof window !== "undefined") {
            document.documentElement.setAttribute("data-theme", theme);
            // document.documentElement.classList.toggle("dark", theme === "dark");
        }
    }, [])

    useEffect(() => {
    if (colorScheme === 'dark') {
        document.documentElement.classList.add("dark");
    } else {
        document.documentElement.classList.remove("dark");
    }
    }, [colorScheme]);

    // useEffect(() => {
    //     if (typeof window !== "undefined") {
    //     document.documentElement.classList.toggle("dark", colorScheme === "dark");
    //     }
    // }, [colorScheme]);

    const toggleColorScheme = () => {
        const newScheme = colorScheme === "dark" ? "light" : "dark";
        setColorScheme(newScheme);
        setClientColorScheme(newScheme);
        localStorage.setItem('mantine-color-scheme', newScheme);
        // ✅ Set the data-theme attribute on <html> for CSS styling
         document.documentElement.setAttribute("data-theme", newScheme);
    }

  return (
    <>
    {/* <DocumentPreviewModal
        file={previewItem ?? null}
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
    /> */}
    <DocumentPreviewModal2
        file={previewItem ?? null}
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
    />

    <div className='top-0 right-0 z-[20000000] flex gap-3 items-center '>
        {/* {pathname !== '/' && (
        <div className=''>
            <NotificationsDropdown />
        </div>
        )} */}
        <Button h={42} w={50} p={0} radius='md' color='transparent' onClick={toggleColorScheme} 
            styles={{
                root: {
                    border: policyPage ? '1px solid #f3e3ca' : ''
                }
            }}
        >
            {colorScheme === 'dark' ? (
                <Image 
                    p={17}
                    src='/vectors/sun-solid.svg' 
                    alt='sun-svg'
                    fit='contain'
                    style={{
                        backgroundColor: '#4D2C1E',
                        
                    }}
                    // style={{backgroundColor: '#4D2C1E'}}
                />
            ) : (
                <Image 
                    p={17}
                    src='/vectors/moon-solid.svg' 
                    alt='moon-svg'
                    fit='contain'
                    style={{backgroundColor: '#4D2C1E'}}
                />
            )}
        </Button>
    </div>
    </>
  )
}

export default ColorSchemeToggle